import { GlobalStatus, JobStatusEnum, PlantsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
@Entity("raw_material")
export class RawMaterial {

    @PrimaryGeneratedColumn("increment", { name: 'prod_inv_id' })
    prodInvId: number;
    @Column({
        nullable: false,
        name: "grn_date"
    })
    grnDate: Date;

    @Column({
        type: 'enum',
        enum: PlantsEnum,
        nullable: true,
        default: PlantsEnum.KAKINADA,
        name: 'plant_id'
    })
    plantId: PlantsEnum;

    // @Column({
    //     type: 'enum',
    //     enum: SubPlantCodesEnum,
    //     nullable: true,
    //     default: SubPlantCodesEnum.KDM,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: SubPlantCodesEnum;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    @Column("int", {
        nullable: false,
        name: "indent_no"
    })
    indentId: number;
    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "grn_number"
    })
    grnNumber: string;
    
    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "lot_number"
    })
    lotNumber: string;

    @Column({
        type: 'enum',
        enum: WorkStationTypeEnum,
        nullable: true,
        default: WorkStationTypeEnum.INTERNAL,
        name: 'workstation_type'
    })
    workStationType: WorkStationTypeEnum;


    @Column("int", {
        nullable: true,
        name: "workstation"
    })
    workStation: number;


    @Column({
        type: 'enum',
        enum: SubPlantCodesEnum,
        nullable: true,
        name: 'external_plant'
    })
    externalPlant: SubPlantCodesEnum;

    @Column({
        type: 'enum',
        enum: JobStatusEnum,
        nullable: true,
        default: JobStatusEnum.OPEN,
        name: 'job_status'
    })
    jobStatus: JobStatusEnum;
    
    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;
    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "supplier_type"
    })
    supplierType: string;
    @Column("int", {
        nullable: false,
        name: "farmer"
    })
    farmer: number;
    @Column("int", {
        nullable: false,
        name: "farmer_code"
    })
    farmerCode: number;
    @Column("int", {
        nullable: true,
        name: "quantity"
    })
    quantity: number;
    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;
    @Column("int", {
        nullable: true,
        name: "price"
    })
    price: number;
    
    @Column("int", {
        nullable: true,
        name: "boxes"
    })
    boxes: number;

    @Column({
        type: 'enum',
        enum: GlobalStatus,
        nullable: true,
        default: GlobalStatus.NO,
        name: 'weighment_req'
    })
    weighmentReq: GlobalStatus;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}

